import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { FadeUp, EASE } from "@/components/Reveal";

export default function FinalCta({ onConsult }) {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden border-t border-white/5 py-32 lg:py-44"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: EASE }}
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <div className="h-[640px] w-[640px] animate-spin-slower rounded-full border border-gold/10" />
      </motion.div>
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(201,163,78,0.09) 0%, transparent 65%)",
        }}
      />

      <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
        <FadeUp>
          <h2
            data-testid="final-cta-headline"
            className="font-serif text-5xl leading-[1.08] tracking-[-0.02em] text-cream sm:text-6xl lg:text-7xl"
          >
            Ready to Grow Your{" "}
            <span className="italic text-gold">Business?</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.15}>
          <p className="mx-auto mt-7 max-w-lg text-base leading-relaxed text-cream/55 md:text-lg">
            Let's build a marketing strategy that delivers measurable results.
          </p>
        </FadeUp>
        <FadeUp delay={0.3}>
          <button
            data-testid="final-cta-btn"
            onClick={() => onConsult()}
            className="btn-gold mt-12 !px-10 !py-4 !text-base"
          >
            Book Your Free Consultation
            <ArrowRight className="h-4 w-4" />
          </button>
        </FadeUp>
      </div>
    </section>
  );
}
